import React from 'react'
import { partners } from '../data/siteData'

const Partners = () => {
  return (
    <div className="Partners">
      <section className="relative py-24 bg-gradient-to-r from-primary-600 to-accent-600">
        <div className="container-custom">
          <div className="text-center text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Nos Partenaires
            </h1>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {partners.map((partner, index) => (
              <div key={index} className="card text-center p-8">
                <div className="w-24 h-24 bg-gray-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <span className="text-2xl font-bold text-primary-500">
                    {partner.name.substring(0, 2)}
                  </span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {partner.name}
                </h3>
                <p className="text-gray-600 mb-4">{partner.type}</p>
                <a 
                  href={partner.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-outline text-sm"
                >
                  Visiter le site
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default Partners 